import { render } from "./WordOverview.vue?vue&type=template&id=794d2538&scoped=true"
import script from "./WordOverview.vue?vue&type=script&lang=js"
export * from "./WordOverview.vue?vue&type=script&lang=js"

import "./WordOverview.vue?vue&type=style&index=0&id=794d2538&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-794d2538"

export default script